import { Injectable } from '@angular/core';

@Injectable()
export class DateUtcToLocalService {
  utcStringToLocalDate(dateString: string) {
      let date = new Date(dateString);
      return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(),  date.getHours(), date.getMinutes(), date.getSeconds()));
  }
  utcDateToLocalDate(date: Date) {
      return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(),  date.getHours(), date.getMinutes(), date.getSeconds()));
  }
}
